import {
  SIGNUP_ACTION,
  SIGNUP_ACTION_LOADER,
  LOGIN_ACTION,
  LOGIN_ACTION_LOADER,
  LOGOUT_ACTION,
  CHECK_AUTH_ACTION,
  CLEAR_AUTH_MESSAGES,
  UPDATE_CUSTOMER_ACTION,
  UPDATE_CUSTOMER_ACTION_LOADER,
  ADD_ADDRESS_ACTION,
  ADD_ADDRESS_SUCCESS,
  ADD_ADDRESS_FAILURE,
  UPDATE_ADDRESS_ACTION,
  UPDATE_ADDRESS_SUCCESS,
  UPDATE_ADDRESS_FAILURE,
  DELETE_ADDRESS_ACTION,
  DELETE_ADDRESS_SUCCESS,
  DELETE_ADDRESS_FAILURE,
  RESET_PASSWORD_ACTION,
  FORGOT_PASSWORD_ACTION,
  RESET_PASSWORD_ACTION_LOADER,
  FORGOT_PASSWORD_ACTION_LOADER
} from "../type";

const initialState = {
  loader: false,
  isAuthenticated: false,
  user: null,
  customer_id: null,
  token: null,
  error: null,
  success: false,
  message: '',
  formType: null
};

// Helper to normalize address API errors
const normalizeAddressError = (msg) => {
  if (!msg) return null;

  if (msg.includes("Address->alias")) return "Address label is required";
  if (msg.includes("Address->address1")) return "Street address is required";
  if (msg.includes("Address->city")) return "City is required";
  if (msg.includes("Address->id_country")) return "Country is required";
  if (msg.includes("Address->postcode")) return "Postcode is required";

  return msg;
};

const AuthReducer = (state = initialState, action) => {
  switch (action.type) {

    // === Loader states ===
    case SIGNUP_ACTION_LOADER:
      return { ...state, loader: action.loader, formType: 'signup' };
    case LOGIN_ACTION_LOADER:
      return { ...state, loader: action.loader, formType: 'login' };
    case UPDATE_CUSTOMER_ACTION_LOADER:
      return { ...state, loader: action.loader, formType: 'updateCustomer' };
    case ADD_ADDRESS_ACTION:
      return { ...state, loader: true, formType: 'addAddress' };
    case UPDATE_ADDRESS_ACTION:
      return { ...state, loader: true, formType: 'updateAddress' };
    case DELETE_ADDRESS_ACTION:
      return { ...state, loader: true, formType: 'deleteAddress' };

    // === Auth / Customer actions ===
    case SIGNUP_ACTION:
      return {
        ...state,
        loader: false,
        success: action.success,
        isAuthenticated: action.success,
        user: action.user || null,
        customer_id: action.customer_id || null,
        token: action.token || null,
        message: action.message || '',
        error: action.error || null,
        formType: 'signup'
      };

    case LOGIN_ACTION:
      return {
        ...state,
        loader: false,
        success: action.success,
        isAuthenticated: action.success,
        user: action.user || null,
        customer_id: action.customer_id || null,
        token: action.token || null,
        message: action.message || '',
        error: action.error || null,
        formType: 'login'
      };

    case UPDATE_CUSTOMER_ACTION:
      return {
        ...state,
        loader: false,
        success: action.success,
        user: action.user || state.user,
        message: action.message || '',
        error: action.error || null,
        formType: 'updateCustomer'
      };

    // === Address actions ===
    case ADD_ADDRESS_SUCCESS:
      return {
        ...state,
        loader: false,
        success: true,
        message: action.message || 'Address added successfully',
        error: null,
        user: action.user || state.user,
        formType: 'addAddress'
      };

    case ADD_ADDRESS_FAILURE:
      return {
        ...state,
        loader: false,
        success: false,
        message: normalizeAddressError(action.message) || action.message || 'Failed to add address',
        error: normalizeAddressError(action.message) || action.message || 'Failed to add address',
        formType: 'addAddress'
      };

    case UPDATE_ADDRESS_SUCCESS:
      return {
        ...state,
        loader: false,
        success: true,
        message: action.message || 'Address updated successfully',
        error: null,
        user: action.user || state.user,
        formType: 'updateAddress'
      };

    case UPDATE_ADDRESS_FAILURE:
      return {
        ...state,
        loader: false,
        success: false,
        message: normalizeAddressError(action.message) || action.message || 'Failed to update address',
        error: normalizeAddressError(action.message) || action.message || 'Failed to update address',
        formType: 'updateAddress'
      };

    case DELETE_ADDRESS_SUCCESS:
      return {
        ...state,
        loader: false,
        success: true,
        message: action.message || 'Address deleted successfully',
        error: null,
        user: state.user
          ? {
              ...state.user,
              addresses: state.user.addresses?.filter(addr => addr.id !== action.payload) || []
            }
          : state.user,
        formType: 'deleteAddress'
      };

    case DELETE_ADDRESS_FAILURE:
      return {
        ...state,
        loader: false,
        success: false,
        message: normalizeAddressError(action.message) || action.message || 'Failed to delete address',
        error: normalizeAddressError(action.message) || action.message || 'Failed to delete address',
        formType: 'deleteAddress'
      };

    case CHECK_AUTH_ACTION:
      return {
        ...state,
        isAuthenticated: action.isAuthenticated,
        user: action.user || null,
        customer_id: action.customer_id || null
      };

    case CLEAR_AUTH_MESSAGES:
      return {
        ...state,
        error: null,
        message: '',
        success: false,
        loader: false,
        formType: null
      };
    case FORGOT_PASSWORD_ACTION_LOADER:
    return {
        ...state,
        loader: action.loader,
        formType: 'forgotPassword',
    };

    case RESET_PASSWORD_ACTION_LOADER:
        return {
            ...state,
            loader: action.loader,
            formType: 'resetPassword',
        };
        case FORGOT_PASSWORD_ACTION:
    return {
        ...state,
        loader: false,
        success: action.success,
        message: action.message || '',
        error: action.error || null,
        formType: 'forgotPassword'
    };

case RESET_PASSWORD_ACTION:
    return {
        ...state,
        loader: false,
        success: action.success,
        message: action.message || '',
        error: action.error || null,
        formType: 'resetPassword'
    };
    case LOGOUT_ACTION:
      return { ...initialState };

    default:
      return state;
  }
};

export default AuthReducer;
